<template lang="pug">
v-tab-item
    feathers-vuex-find(service="bh-market-items" :query="dataQuery" :fetch-query="fetchQuery" watch="query")
        v-card(slot-scope="{ items: desserts, pagination: serverPagination, isFindPending }")
            v-card-title Marketplace
                v-spacer
                v-text-field(v-model="searchUser" append-icon="mdi-magnify" label="Search Name" single-line hide-details)
                new-martket-item(@success="$emit('success')" @error="$emit('error', $event)" :type="type")
            v-data-table(
                :headers="headers"
                :loading="isFindPending"
                :items="isFindPending ? [] : desserts"
                :options.sync="pagination"
                :server-items-length="!serverPagination ? 0 : serverPagination.mostRecent.total"
                :footer-props="{ showCurrentPage: true, itemsPerPageOptions: [10, 15, 20, 25, 30] }"
                loading-text="Fetching Data..."
            )
                //- template(v-slot:item.artist_name="{ item }")
                //-     v-avatar(size="30" style="margin-right: 10px;")
                //-         img(:src="item.profile_picture_thumb")
                //-     a(:href="`http://www.breakinghits.app/${item.url}`" :target="`__user-${item.id}`") {{ item.artist_name }}
                template(v-slot:item.item_id="{ item }")
                    center
                        img(:src="item.item.image" :height="64")
                        br
                        | {{ item.item.name }}

                template(v-slot:item.createdAt="{ item }") {{ item.createdAt | dateFormat }}
                template(v-slot:item.actions="{ item }")
                    new-martket-item(@success="$emit('success')" @error="$emit('error', $event)" :item="item")
                    delete-market-item(:item="item" @error="$emit('error', $event)")
                //-     dialog-show-qr-code(:item="item")
                //-     dialog-add-code(:item="item")
</template>

<script>
import moment from 'moment';
import NewMartketItem from './NewMarketItem';
import DeleteMarketItem from './DeleteMarketItem.vue';
import { mapActions } from 'vuex';

export default {
    props: {
        type: String()
    },
    data() {
        return {
            searchUser: '',
            headers: [
                {
                    text: 'ID',
                    align: 'start',
                    sortable: true,
                    value: 'id'
                },
                {
                    text: 'Item Info',
                    align: 'center',
                    sortable: false,
                    value: 'item_id'
                },
                {
                    text: 'Cost',
                    align: 'end',
                    sortable: false,
                    value: 'price'
                },
                {
                    text: 'Type',
                    align: 'end',
                    sortable: false,
                    value: 'type'
                },
                {
                   text: 'Date Created',
                    align: 'end',
                    sortable: true,
                    value: 'createdAt'
                },
                {
                    text: 'Actions',
                    align: 'end',
                    sortable: false,
                    value: 'actions'
                }
            ],
            pagination: {
                page: 1,
                itemsPerPage: 10,
                sortBy: ['createdAt'],
                sortDesc: [true]
            },
            query: {
                type: this.type
            },
        };
    },
    filters: {
        dateFormat(date) {
            if(date) {
                return moment(date).format('lll');
            }

            return 'n/a';
        },
        status(status) {
            switch(status) {
                case 0: return 'Inactive';
                case 1: return 'Active';
            }
        }
    },
    computed: {
        extendedQuery() {
            if(this.user) {
                return {
                    // id: { $nin: [this.user.id] }
                };
            }
            return null;
        },
        searchQuery() {
            if(this.searchUser) {
                return {
                    $or: [
                        { code: { $like: `%${this.searchUser}%` } },
                    ]
                };
            }
            return null;
        },
        searchDataQuery() {
            if(this.searchUser) {
                return {
                    $or: [
                        { code: { $regex: new RegExp(`.*${this.escapeRegex(this.searchUser)}.*`, 'gi') } },
                    ]
                };
            }
            return null;
        },
        sortingQuery() {
            if(this.pagination.sortBy.length !== 0) {
                const $sort = {};
                this.pagination.sortBy.map((item, index) => {
                    switch(item) {
                        default:
                            $sort[item] = this.pagination.sortDesc[index] ? -1 : 1;
                    }
                    
                });
                return { $sort };
            }
            return null;
        },
        dataQuery() {
            return {
                ...this.query,
                ...this.extendedQuery,
                ...this.searchDataQuery,
                $limit: this.pagination.itemsPerPage,
                $skip: (this.pagination.page-1) * this.pagination.itemsPerPage,
                ...this.sortingQuery
            };
        },
        fetchQuery() {
            return Object.assign({}, {
                ...this.query,
                ...this.extendedQuery,
                // $populate: true
            }, {
                ...this.searchQuery,
                $limit: this.pagination.itemsPerPage,
                $skip: (this.pagination.page-1) * this.pagination.itemsPerPage,
                ...this.sortingQuery
            });
        },
    },
    methods: {
        escapeRegex(string) {
            return string.replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&');
        },
        ...mapActions('bh-market-items', { removeItem: 'remove' })
    },
    components: {
        NewMartketItem,
        DeleteMarketItem
    }
}
</script>